import { useEffect, useState } from 'react'
import { roles } from 'consts'
import loadPages from 'utils/loadPages'
import { getCustomData } from 'shared/components/App/Auth'
import hasAnyRole from 'shared/utils/hasAnyRole'
import { getAllCustomData } from 'shared/components/App/Auth'

interface useFilterRoleChangedProps {
  filterRole: object | null
  setPage: Function
  setToken: Function
  setReports: Function
}

const useFilterRoleChanged = (props: useFilterRoleChangedProps) => {
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)
  const isSuperadmin: boolean = hasAnyRole([roles.superAdmin])
  const customData = getAllCustomData()
  const customerActive = (customData?.customer && (customData.customer.active === 1)) ? true : false
  const loadFromServer = isSuperadmin || customerActive

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false)
    } else {
      loadPages({
        role: getCustomData('role'),
        customer: getCustomData('customer') ?? false,
        loadFromServer
      }).then((pages) => {
        const page = pages.find((item) => {
          return (
            item?.path &&
            item.path.length &&
            item?.roles &&
            (isSuperadmin || item.roles.includes(getCustomData('role')))
          )
        })
        window.location.href = page && typeof page.path === 'string' ? page.path : '/'
      })
    }
  }, [props.filterRole])
}

export default useFilterRoleChanged
